import React, { ReactNode } from 'react'
import { createRoot } from 'react-dom/client'
import { ThemeProvider } from 'styled-components'

import { theme } from '../../../lib/theme'

import createContainer from './CreateContainer'
import { NotificationTypes } from './Notification'
import NotificationManager, { INotification } from './NotificationsManager'

const containerElement = createContainer()
const root = createRoot(containerElement)

export function notify(notification: INotification) {
    const NotificationsManagerElement = (
        <ThemeProvider theme={theme}>
            <NotificationManager notification={notification} />
        </ThemeProvider>
    )

    root.render(NotificationsManagerElement)
}

export function notifyInfo(message: ReactNode, autoClose?: boolean) {
    return notify({
        type: NotificationTypes.Info,
        message,
        autoClose,
    })
}

export function notifySuccess(message: ReactNode, autoClose?: boolean) {
    return notify({
        type: NotificationTypes.Success,
        message,
        autoClose,
    })
}

export function notifyWarning(message: ReactNode, autoClose?: boolean) {
    return notify({
        type: NotificationTypes.Warning,
        message,
        autoClose,
    })
}

export function notifyError(message: ReactNode, autoClose?: boolean) {
    return notify({
        type: NotificationTypes.Error,
        message,
        autoClose,
    })
}
